export var LEMNISCATE="∞";export var EMPTY_SPACE="\xa0";
//# sourceMappingURL=textSymbols.js.map